import React from 'react'
import { Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { dataMarts } from '../../../../../api/coreData'
import Loading from '../../../../molecules/Loading'
import AdminPage from '../../../admin/shared/AdminPage'
import ErrorDisplay from '../../../../molecules/ErrorDisplay'
import { useConfigColumns } from '../../../../../hooks/useConfigColumns'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'
import OperationalTable from '../../../../organisms/OperationalTable'
import FlexRow from '../../../../molecules/FlexRow'
import SydLinkButton from '../../../../commonDesign/LinkButton'
import DataMartStatusBadge, { DataMartStatusDate } from './EditDataMart/DataMartStatusBadge'

const columnConfig = {
  columns: [
    { id: 'name', accessor: 'name', Header: 'Name' },
    {
      id: 'status',
      accessor: 'timeSeriesId',
      Header: 'Status',
      Cell: (cell) => <DataMartStatusBadge timeSeriesId={cell.value} variant='compact' />
    },
    {
      id: 'lastRun',
      accessor: 'timeSeriesId',
      Header: 'Last Run',
      Cell: (cell) => <DataMartStatusDate timeSeriesId={cell.value} />
    },
    {
      id: 'workflowType',
      accessor: (row) => row.configuration?.workflowType ?? '-',
      Header: 'Type'
    },
    {
      id: 'sourcePipelineId',
      accessor: (row) => row.configuration?.sourcePipelineId ?? '-',
      Header: 'Pipeline'
    },
    {
      id: 'tableName',
      accessor: (row) => row.configuration?.tableConfiguration?.tableName ?? '-',
      Header: 'Table'
    },
    {
      id: 'enabled',
      accessor: (row) => row.enabled ? 'Yes' : 'No',
      Header: 'Enabled'
    }
  ],
  defaultSort: [{ id: 'name', desc: false }]
}

function DataMartsHome () {
  const { data, isLoading, error, refetch } = dataMarts.useSearchDataMarts()
  const { formatter } = useFormattingContext()
  const _columns = useConfigColumns({
    columnsConfig: columnConfig,
    format: formatter
  })
  const history = useHistory()

  if (error) {
    return (
      <AdminPage>
        <ErrorDisplay error={error} onRetry={refetch} />
      </AdminPage>
    )
  }

  if (isLoading) {
    return (
      <AdminPage>
        <Loading />
      </AdminPage>
    )
  }

  return (
    <AdminPage>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FlexRow style={{ justifyContent: 'space-between' }}>
            <h2>Data Marts</h2>
            <div>
              <SydLinkButton
                to='/admin/denali/analysis/data-marts/new'
                icon='add'
                size='sm'
                variant='primary'
              >
                New
              </SydLinkButton>
            </div>
          </FlexRow>
        </Grid>
        <Grid item xs={12}>
          <OperationalTable
            variant='v2'
            itemName='Data Marts'
            columns={_columns.columns}
            defaultSort={_columns.defaultSort}
            data={data?.data || []}
            onRowClick={row => history.push(`/admin/denali/analysis/data-marts/${row.original.timeSeriesId}`)}
          />
        </Grid>
      </Grid>
    </AdminPage>
  )
}

DataMartsHome.propTypes = {}

export default DataMartsHome
